<template>
  <button
    type="button"
    class="btn btn-success"
    data-toggle="modal"
    data-target=".bd-add-job-modal-lg"
    style="white-space: nowrap;"
  >
    <slot />
  </button>
</template>

<script>
export default {};
</script>

<style>
</style>